var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-top",style:(_vm.style),on:{"click":function($event){$event.stopPropagation();return _vm.scrollToTop.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }